import React, { JSX } from "react";
import { Box, Tabs, Tab } from "@mui/material";

import ProfileSetting from "./ProfileSetting";
import { UserAttendance } from "./Attendance/UserAttendance";
import usePayroll from "../../../hooks/usePayroll";
import UserLeaveApplications from "./LeaveApplication/UserLeaveApplications";
import UserSalaries from "./Salary/UserSalaries";
import { UserShifts } from "./Shifts/UserShifts";

export default function AttendanceLayout(): JSX.Element {
  const { isPayrollSubscribed } = usePayroll();
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ height: "100%", width: "100%", display: "flex", flexDirection: "column" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={value} onChange={handleChange}>
          <Tab label="Profile Settings" />
          {isPayrollSubscribed && <Tab label="Attendance" />}
          {isPayrollSubscribed && <Tab label="Shifts" />}
          {isPayrollSubscribed && <Tab label="Leave Application" />}
          {isPayrollSubscribed && <Tab label="Salary History" />}
        </Tabs>
      </Box>

      <Box sx={{ flexGrow: 1, overflowY: "auto" }}>
        {value === 0 && <ProfileSetting />}
        {value === 1 && <UserAttendance />}
        {value === 2 && <UserShifts />}
        {value === 3 && <UserLeaveApplications />}
        {value === 5 && <UserSalaries />}
      </Box>
    </Box>
  );
}
